import "regenerator-runtime/runtime"; // para funciones async, await

require('core-js/es/object')
require('core-js/es/symbol')
require('core-js/es/parse-int')
require('core-js/es/function')
require('core-js/es/number')
require('core-js/es/parse-float')
require('core-js/es/math')
require('core-js/es/string')
require('core-js/es/date')
require('core-js/es/array')
require('core-js/es/regexp')
require('core-js/es/map')
require('core-js/es/weak-map')
require('core-js/es/set')
// require("core-js/es7/object");
// import 'core-js/es7/object'; // added import

// para decorators
require('reflect-metadata')
require('core-js/es/reflect')
